import axios from "axios"
import { userPayload } from "@/global"

const success = res => res

const error = err => {
  if (401 === err.response.status) {
    localStorage.removeItem(userPayload)
    window.location = "/login"
  } else {
    return Promise.reject(err)
  }
}

axios.interceptors.response.use(success, error)
